<template>
<div class="fill-height pb-5 ">
    <v-layout class="pa-0" row wrap style="z-index:4!important; position:relative" align-center>
        <v-flex xs7 class="pb-5 px-3 font-weight-bold" style="color:#777; font-size:0.9em;">
            {{$store.state.categories[listing.category].categorySingularName}}
        </v-flex>
        <v-flex xs5 class="pl-5 px-0">                    
            <div class="award-container" :style="'background-image:url('+award+')'"></div>
        </v-flex>
    </v-layout>
    <v-card class="listing-card pb-5 px-2 pt-4" style="margin-top:-45px; position:relative" @click="$router.push({name:'listing', params:{fakename:listing.companyName.split(' ').join('_'), id:listingKey}})">
        <v-card-text class="pa-0">
            <v-layout row wrap>
                <v-flex xs12 class="company-name-container">
                    <router-link class="simple-link" :to="{name:'listing', params:{fakename:listing.companyName.split(' ').join('_'), id:listingKey}}">
                        <span class="company-name my-0">{{listing.companyName}}</span>
                    </router-link>
                </v-flex>
            </v-layout>
            <v-layout row wrap>
                <v-flex xs12>
                    <div class="logo-container" :style="{'background-image':'url('+(listing.logoUrl || logo||'https://dummyimage.com/250x250/888/fff.png')+')'}">                            
                    </div> 
                </v-flex>
            </v-layout>
            <v-layout class="mt-2 mb-5" row wrap>
                <v-flex style="height:100px">{{listing.aboutUs ? listing.aboutUs.substring(0,180)+'...' : ''}}</v-flex>
            </v-layout>
        </v-card-text>
    </v-card>
    <v-layout style="margin-top:-20px; margin-bottom:30px; padding:0 30px;" row wrap align-center>
        <v-btn block v-if="listing.requestButton && !added" color="primary" class="ma-0 elevation-7" @click="addRequest()">Request Free Info <v-icon right>check_box_outline_blank</v-icon></v-btn>
        <v-btn block v-if="listing.requestButton && added" color="black" dark class="ma-0 elevation-7" @click="removeRequest()">Remove Request <v-icon right>check_box</v-icon></v-btn>   
    </v-layout>
</div>
</template>

<script>
import firebase from '@/firebase.js';

export default {
    props:['listing', 'listingKey'],

    data() {
        return {
            header:'',
            logo:'',
            added:false,
            award:'',
        }
    },

    created() {
        firebase.storage().ref().child('/listings/'+this.listingKey).child('/header.png').getDownloadURL()
        .then((url)=>{
            this.header = url;
        });

        firebase.storage().ref().child('/listings/'+this.listingKey).child('/logo.png').getDownloadURL()
        .then((url)=>{
            this.logo = url;
        });

        if (this.listing.award) {
            firebase.storage().ref().child('/awards/'+this.listing.award).child('/badge.png').getDownloadURL().then((url)=>{
                this.award = url;
            });
        }
    },

    methods: {
        addRequest() {
            this.added = true;
            this.$emit('add-request', this.listingKey);
        },

        removeRequest() {
            this.added = false;
            this.$emit('remove-request', this.listingKey);
        }
    }
}
</script>

<style scoped>
    .logo-container {
        position: relative;
        height: 0;
        overflow: hidden;
        padding-top:45%;
        background-size: contain;
        background-position: 50%;
    }

    .header-container {
        position: relative;
        height: 0;
        overflow: hidden;
        padding-top:23%;
        background-size: cover;
        background-position: 50%;
    }

    .award-container {
        width: 100%;
        padding-top: 100%;
        background-position: 50%;
        background-size: contain;
    }

    .card-shadow {
        box-shadow: 0 4px 5px -2px rgba(0,0,0,0.14),0 7px 10px 1px rgba(0,0,0,0.1),0 2px 16px 1px rgba(0,0,0,0.08)!important;
    }

    
    .simple-link {
        text-decoration: none;
        color: #555!important;
        display: block;
        text-align: center;
        line-height: 4.5em;
    }

    .company-name{
        display: inline-block;
        line-height: 1.2em;
        vertical-align: middle;
        text-align: center;
        font-size: 1.25em!important;
        padding: 0;
        font-weight: 700!important;
        font-family: 'Arial', sans-serif;
        vertical-align: middle;
        color: #555!important;
    }

    .listing-card{
        border-radius: 10px;
        cursor: pointer;
    }

    .listing-card:hover .company-name {
        color: #f6b143!important;
    }

    .listing-card:hover {        
        box-shadow: 0px 4px 15px -2px rgba(0,0,0,0.3);
    }

    

</style>
